export default {
      id: "delayedData-usage",
      viewBox: "0 0 16 14",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#delayedData",
      toString: function () {
        return this.url;
      }
    }